import { Modal, ProgressBar } from '../../components/BootstrapToMUI';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import request from '../../services/Request';
import { TextField, Button, MenuItem, IconButton, Box, Typography } from '@mui/material';
import { DeleteForeverOutlined } from '@mui/icons-material';
import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import { Controller, useForm } from 'react-hook-form';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Autocomplete } from '@mui/material';
import { Checkbox, Select, Divider } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { InputAdornment } from '@mui/material';
import { languages, languages_noEn } from '../../staticData/languages';
import { currencies, noUScurrencies } from '../../staticData/currencies';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { roundUp } from '../../services/method/methods';
import { useTheme } from '@mui/material/styles';

const DF_DETAIL = 55;
const TW_DETAIL = 110;
const TW_NAME = 28;
const DF_NAME = 34;
const MAXLENGTH = 2000;
const UPC = 16;
const TITLELENGTH = 20;
const IMAGELIMIT = 5000000;
const STEP_DEPTH = 2.4;
const LANE_LENGTH = 7.8;

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AddProduct(props) {
  const { productsDash, isBundle, ...rest } = props;
  const theme = useTheme();
  const { userEmail, role, referTo } = useContext(UserContext);
  const user = JSON.parse(localStorage.getItem('user'));
  const additionPriceOn = user?.features?.additionPrice;
  const theme1 = user?.theme === '1';
  const advanced = user?.features?.advanced;
  const extra = user?.features?.extra;
  const langs = user?.langs;
  const primaryCurrencySymbol = currencies.find((c) => c.code === (user?.primaryCurrency || 'USD'))?.symbol || '$';

  const [arrow, setArrow] = useState(false);

  const defaultValues = {
    ppRadio: isBundle ? 'bundle' : 'prod',
    name: '',
    prods: [],
    select: 'en',
    selectPrice: 'USD',
    upc: '',
    price: '',
    costPrice: '',
    descrition: '',
    title1: '',
    title2: '',
    detail: '',
    category: [],
    labels: [],
    ingredients: '',
    keyFeatures: '',
    specification: '',
    include: '',
    allergens: '',
    brand: null,
    length: '',
    width: '',
    height: '',
    image1: null,
    image2: null,
    image3: null,
    video: null,
    autoTrans: false,
    tax_type: '0',
    externalCode: '',
  };
  let langArray = [];
  let enArray = [languages[0]];
  if (langs?.length > 0) {
    langs.forEach((lan) => {
      const index = languages_noEn.findIndex((e) => e.code === lan);
      if (index > -1) {
        langArray.push(languages_noEn[index]);
        enArray.push(languages_noEn[index]);
      }
    });
  }

  langArray.forEach((e) => {
    defaultValues[e.code + 'Name'] = '';
    defaultValues[e.code + 'Desc'] = '';
    defaultValues[e.code + 'title1'] = '';
    defaultValues[e.code + 'title2'] = '';
    defaultValues[e.code + 'Ingre'] = '';
    defaultValues[e.code + 'Detail'] = '';
    defaultValues[e.code + 'Key'] = '';
    defaultValues[e.code + 'Spec'] = '';
    defaultValues[e.code + 'Include'] = '';
    defaultValues[e.code + 'Detail'] = '';
    defaultValues[e.code + 'Aller'] = '';
  });

  if (additionPriceOn) {
    noUScurrencies.forEach((e) => {
      defaultValues[e.code + 'Price'] = '';
    });
  }

  const {
    handleSubmit,
    control,
    register,
    setError,
    clearErrors,
    getValues,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  let id = '';
  let userId = useLocation().pathname.split('/').slice(-1)[0];

  if (userId.includes('@')) {
    id = userId;
  } else {
    if (role === 'Admin') id = userEmail;
    else id = referTo;
  }

  const [categories, setCategories] = useState([]);
  const [labels, setLabels] = useState([]);
  const [brands, setBrands] = useState([]);
  const [percent, setPercent] = useState(0);
  const watchAllFields = watch();

  const handleRemove = (input) => {
    setPercent(0);
    setValue(input);
  };

  useEffect(() => {
    if (props.show) {
      reset(defaultValues);
      setPercent(0);
    }
  }, [props.show]);

  useEffect(() => {
    if (props.show) {
      if (id) {
        request({
          method: 'get',
          url: `/categories/${id}`,
        }).then((res) => {
          setCategories(res.data);
        });
        if (!extra) {
          request({
            method: 'get',
            url: `/labels/${id}`,
          }).then((res) => {
            setLabels(res.data);
          });
        }

        request({
          method: 'get',
          url: `/brands/${id}`,
        }).then((res) => {
          setBrands(res.data);
        });
      }

      return () => {
        setCategories([]);
        setBrands([]);
      };
    }
  }, [props.show]);

  const currentSymbol = () => {
    const found = currencies.find((c) => c.code === watchAllFields?.selectPrice);
    if (found) return found.symbol;
    return primaryCurrencySymbol;
  };

  const onSubmit = (formData) => {
    const category = formData.category.map((e) => e._id);
    const labels = formData.labels.map((e) => e._id);
    const myData = new FormData();

    let name = { en: formData.name };
    let title1 = { en: formData.title1 };
    let title2 = { en: formData.title2 };
    let description = { en: formData.description };
    let detail = { en: formData.detail };
    let keyFeatures = { en: formData.keyFeatures };
    let include = { en: formData.include };
    let specification = { en: formData.specification };
    let ingredients = { en: formData.ingredients };
    let allergens = { en: formData.allergens };

    let addition = {};
    const isEmptyAddition = [
      formData.id_familia,
      formData.id_subfamilia,
      formData.subconcepto,
    ].every((e) => !e || e === '');
    if (!isEmptyAddition) {
      if (formData.id_familia) {
        addition.id_familia = formData.id_familia;
        addition.id_subfamilia = formData.id_subfamilia;
        addition.subconcepto = formData.subconcepto;
      }
      myData.append('addition', JSON.stringify(addition));
    }

    if (additionPriceOn) {
      let additionPrice = {};
      noUScurrencies.forEach((e) => {
        if (formData[e.code + 'Price'] !== '') {
          additionPrice[e.code] = parseFloat(formData[e.code + 'Price']);
        }
      });
      if (Object.keys(additionPrice).length !== 0)
        myData.append('additionPrice', JSON.stringify(additionPrice));
    }

    langArray.forEach((e) => {
      if (formData[e.code + 'Name'] !== '') {
        name[e.code] = formData[e.code + 'Name'];
      }
      if (formData[e.code + 'Title1'] !== '') {
        title1[e.code] = formData[e.code + 'Title1'];
      }
      if (formData[e.code + 'Title2'] !== '') {
        title2[e.code] = formData[e.code + 'Title2'];
      }
      if (formData[e.code + 'Desc'] !== '') {
        description[e.code] = formData[e.code + 'Desc'];
      }

      if (formData[e.code + 'Ingre'] !== '') {
        ingredients[e.code] = formData[e.code + 'Ingre'];
      }
      if (formData[e.code + 'Aller'] !== '') {
        allergens[e.code] = formData[e.code + 'Aller'];
      }

      if (theme1) {
        if (formData[e.code + 'Detail'] !== '') {
          detail[e.code] = formData[e.code + 'Detail'];
        }
        if (formData[e.code + 'Key'] !== '') {
          keyFeatures[e.code] = formData[e.code + 'Key'];
        }
        if (formData[e.code + 'Spec'] !== '') {
          specification[e.code] = formData[e.code + 'Spec'];
        }
        if (formData[e.code + 'Include'] !== '') {
          include[e.code] = formData[e.code + 'Include'];
        }
      }
    });
    myData.append('name', JSON.stringify(name));
    myData.append('description', JSON.stringify(description));
    myData.append('title1', JSON.stringify(title1));
    myData.append('title2', JSON.stringify(title2));

    myData.append('referTo', id);
    myData.append('auto', formData.autoTrans);
    if (langs?.length > 0) {
      langs.forEach((e) => {
        myData.append('langs', e);
      });
    }
    myData.append('upc', formData.upc.trim());
    myData.append('price', formData.price);
    if (formData.costPrice) {
      myData.append('costPrice', formData.costPrice);
    }

    myData.append('detail', JSON.stringify(detail));

    if (theme1) {
      myData.append('keyFeatures', JSON.stringify(keyFeatures));
      myData.append('specification', JSON.stringify(specification));
      myData.append('include', JSON.stringify(include));
    }
    myData.append('ingredients', JSON.stringify(ingredients));
    myData.append('allergens', JSON.stringify(allergens));
    myData.append('tax_type', formData.tax_type);
    myData.append('externalCode', formData.externalCode);

    if (category.length > 0 || category.length !== '') {
      category.forEach((e) => {
        myData.append('category', e);
      });
    } else myData.append('category', null);
    if (labels.length > 0 || labels.length !== '') {
      labels.forEach((e) => {
        myData.append('labels', e);
      });
    } else myData.append('labels', null);
    if (formData.brand) {
      myData.append('brand', formData.brand);
    }
    myData.append('pp', watchAllFields.ppRadio);
    if (watchAllFields.ppRadio == 'prod') {
      myData.append('length', formData.length);
      myData.append('width', formData.width);
      myData.append('height', formData.height);
    } else {
      myData.append('bundle_prod', JSON.stringify(formData.prods));
    }

    if (formData.image1 && formData.image1.length > 0) myData.append('image1', formData.image1[0]);
    if (formData.image2 && formData.image2.length > 0) myData.append('image2', formData.image2[0]);
    if (formData.image3 && formData.image3.length > 0) myData.append('image3', formData.image3[0]);
    if (formData.video && formData.video.length > 0) myData.append('video', formData.video[0]);
    for (var value of myData.values()) {
      console.log(value);
    }

    request({
      method: 'post',
      url: `/products/create`,
      data: myData,
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total);
        if (percent < 100) {
          setPercent(percent);
        }
      },
    })
      .then((res) => {
        setPercent(100, () => {
          setTimeout(() => {
            setPercent(0);
          }, 1000);
        });
        Swal.fire({
          text: `New product has been successfully created`,
          icon: 'success',
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 406) {
            setError('upc', {
              message: err.response.data.message,
            });
          } else {
            Swal.fire({
              text: err.response.data.error,
              icon: 'error',
            });
          }
        }
      });
  };

  return (
    <Modal {...rest} centered scrollable className="mt-5 myModal" size="sm">
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          sx={{ fontSize: '1.25rem', fontWeight: 600 }}
        >
          {watchAllFields.ppRadio == 'prod' ? 'Add a New Product' : 'Add a New Bundle'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body sx={{ px: 3.5, py: 3 }}>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container spacing={2.5}>
                <Grid item xs={advanced ? 7 : 12}>
                  <Controller
                    render={({ field }) => (
                      <Select fullWidth defaultValue="en" {...field} variant="outlined">
                        {enArray.map((e, i) => {
                          return (
                            <MenuItem key={i} value={e.code}>
                              {e.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    )}
                    name="select"
                    control={control}
                  />
                </Grid>
                {advanced && (
                  <Grid
                    item
                    xs={5}
                    sx={{
                      display: 'flex',
                      alignContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Controller
                      name="autoTrans"
                      control={control}
                      render={({ field }) => <Checkbox {...field} />}
                    />
                    <Typography variant="body1">Auto Translate</Typography>
                  </Grid>
                )}

                <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                  <Controller
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        label={`Name (Max ${theme1 ? TW_NAME : DF_NAME} Characters)`}
                        variant="outlined"
                        inputProps={
                          theme1
                            ? {
                                maxLength: TW_NAME,
                              }
                            : {
                                maxLength: DF_NAME,
                              }
                        }
                        {...field}
                      />
                    )}
                    name="name"
                    control={control}
                    rules={{
                      required: 'Product Name is required',
                      validate: () => {
                        if (getValues('name').includes(',')) {
                          return 'Product Name cannot contain comma';
                        }
                      },
                    }}
                  />
                  {errors.name && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.name.message}</Typography>
                  )}
                </Grid>

                {langArray.map((e) => {
                  return (
                    <Grid item xs={12} hidden={watchAllFields.select !== e.code} key={e.code}>
                      <Controller
                        name={e.code + 'Name'}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            label={`Name (Max ${theme1 ? TW_NAME : DF_NAME} Characters)`}
                            variant="outlined"
                            inputProps={
                              theme1
                                ? {
                                    maxLength: TW_NAME,
                                  }
                                : {
                                    maxLength: DF_NAME,
                                  }
                            }
                            fullWidth
                            {...field}
                          />
                        )}
                      />
                    </Grid>
                  );
                })}

                <Grid item container spacing={2}>
                  <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                    <Controller
                      render={({ field }) => (
                        <TextField
                          fullWidth
                          label={`Details (Max ${theme1 ? TW_DETAIL : DF_DETAIL} Characters)`}
                          variant="outlined"
                          inputProps={
                            theme1
                              ? {
                                  maxLength: TW_DETAIL,
                                }
                              : {
                                  maxLength: DF_DETAIL,
                                }
                          }
                          multiline
                          maxRows={3}
                          {...field}
                        />
                      )}
                      name="detail"
                      control={control}
                    />
                  </Grid>
                  {errors.detail && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.detail.message}</Typography>
                  )}

                  {langArray.map((e, i) => {
                    return (
                      <Grid key={i} item xs={12} hidden={watchAllFields.select !== e.code}>
                        <Controller
                          name={e.code + 'Detail'}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              fullWidth
                              label={`Details (Max ${theme1 ? TW_DETAIL : DF_DETAIL} Characters)`}
                              variant="outlined"
                              inputProps={
                                theme1
                                  ? {
                                      maxLength: TW_DETAIL,
                                    }
                                  : {
                                      maxLength: DF_DETAIL,
                                    }
                              }
                              multiline
                              maxRows={3}
                              {...field}
                            />
                          )}
                        />
                      </Grid>
                    );
                  })}
                </Grid>

                <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                  <Controller
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        label="Description"
                        variant="outlined"
                        inputProps={{
                          maxLength: MAXLENGTH,
                        }}
                        InputLabelProps={{ shrink: true }}
                        multiline
                        maxRows={6}
                        {...field}
                      />
                    )}
                    name="description"
                    rules={{ required: 'Description is required' }}
                    control={control}
                  />
                </Grid>
                {errors.description && (
                  <Typography color="error" sx={{ ml: 1 }}>{errors.description.message}</Typography>
                )}

                {langArray.map((e, i) => {
                  return (
                    <Grid item xs={12} hidden={watchAllFields.select !== e.code} key={i}>
                      <Controller
                        name={e.code + 'Desc'}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            label="Description"
                            variant="outlined"
                            inputProps={{
                              maxLength: MAXLENGTH,
                            }}
                            InputLabelProps={{ shrink: true }}
                            multiline
                            maxRows={6}
                            fullWidth
                            {...field}
                          />
                        )}
                      />
                    </Grid>
                  );
                })}

                {watchAllFields.ppRadio == 'prod' && theme1 && (
                  <Grid item container rowSpacing={1.5} xs={12}>
                    <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                      <Controller
                        render={({ field }) => (
                          <TextField
                            fullWidth
                            label="Key Features(Separate by ; for exmaple: feature1;feature2;feature3)"
                            variant="outlined"
                            inputProps={{
                              maxLength: MAXLENGTH,
                            }}
                            multiline
                            maxRows={3}
                            {...field}
                          />
                        )}
                        name="keyFeatures"
                        control={control}
                      />
                    </Grid>
                    {errors.keyFeatures && (
                      <Typography color="error" sx={{ ml: 1 }}>
                        {errors.keyFeatures.message}
                      </Typography>
                    )}
                    {langArray.map((e, i) => {
                      return (
                        <Grid key={i} item xs={12} hidden={watchAllFields.select !== e.code}>
                          <Controller
                            name={e.code + 'Key'}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                label="Key Features(Separate by ; for exmaple: feature1;feature2;feature3)"
                                variant="outlined"
                                inputProps={{
                                  maxLength: MAXLENGTH,
                                }}
                                multiline
                                maxRows={3}
                                fullWidth
                                {...field}
                              />
                            )}
                          />
                        </Grid>
                      );
                    })}

                    <Grid item xs={12}>
                      <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                        <Controller
                          render={({ field }) => (
                            <TextField
                              fullWidth
                              label="Specification (Separate by ; for exmaple: feature1;feature2;feature3)"
                              variant="outlined"
                              inputProps={{
                                maxLength: MAXLENGTH,
                              }}
                              multiline
                              maxRows={3}
                              {...field}
                            />
                          )}
                          name="specification"
                          control={control}
                        />
                      </Grid>
                      {errors.specification && (
                        <Typography color="error" sx={{ ml: 1 }}>
                          {errors.specification.message}
                        </Typography>
                      )}
                      {langArray.map((e, i) => {
                        return (
                          <Grid key={i} item xs={12} hidden={watchAllFields.select !== e.code}>
                            <Controller
                              name={e.code + 'Spec'}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  label="Specification (Separate by ; for exmaple: feature1;feature2;feature3)"
                                  variant="outlined"
                                  inputProps={{
                                    maxLength: MAXLENGTH,
                                  }}
                                  multiline
                                  maxRows={3}
                                  fullWidth
                                  {...field}
                                />
                              )}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>

                    <Grid item xs={12}>
                      <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                        <Controller
                          render={({ field }) => (
                            <TextField
                              fullWidth
                              label="Includes (Separate by ; for exmaple: feature1;feature2;feature3)"
                              variant="outlined"
                              inputProps={{
                                maxLength: MAXLENGTH,
                              }}
                              multiline
                              maxRows={3}
                              {...field}
                            />
                          )}
                          name="include"
                          control={control}
                        />
                      </Grid>
                      {errors.include && (
                        <Typography color="error" sx={{ ml: 1 }}>{errors.include.message}</Typography>
                      )}
                      {langArray.map((e, i) => {
                        return (
                          <Grid key={i} item xs={12} hidden={watchAllFields.select !== e.code}>
                            <Controller
                              name={e.code + 'Include'}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  label="Includes (Separate by ; for exmaple: feature1;feature2;feature3)"
                                  variant="outlined"
                                  multiline
                                  inputProps={{
                                    maxLength: MAXLENGTH,
                                  }}
                                  maxRows={3}
                                  fullWidth
                                  {...field}
                                />
                              )}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                )}

                <Grid item xs={12} container spacing={2}>
                  <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                    <Controller
                      render={({ field }) => (
                        <TextField
                          fullWidth
                          label="Title 1"
                          variant="outlined"
                          inputProps={{
                            maxLength: TITLELENGTH,
                          }}
                          InputLabelProps={{ shrink: true }}
                          {...field}
                        />
                      )}
                      name="title1"
                      control={control}
                    />
                  </Grid>
                  {errors.title1 && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.title1.message}</Typography>
                  )}
                  {langArray.map((e, i) => {
                    return (
                      <Grid key={i} item xs={12} hidden={watchAllFields.select !== e.code}>
                        <Controller
                          name={e.code + 'Title1'}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label="Title 1"
                              variant="outlined"
                              inputProps={{
                                maxLength: MAXLENGTH,
                              }}
                              InputLabelProps={{ shrink: true }}
                              fullWidth
                              {...field}
                            />
                          )}
                        />
                      </Grid>
                    );
                  })}

                  <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                    <Controller
                      render={({ field }) => (
                        <TextField
                          fullWidth
                          label={'Extra Info 1'}
                          variant="outlined"
                          inputProps={{
                            maxLength: MAXLENGTH,
                          }}
                          multiline
                          maxRows={3}
                          {...field}
                        />
                      )}
                      name="ingredients"
                      control={control}
                    />
                  </Grid>
                  {errors.ingredients && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.ingredients.message}</Typography>
                  )}
                  {langArray.map((e, i) => {
                    return (
                      <Grid key={i} item xs={12} hidden={watchAllFields.select !== e.code}>
                        <Controller
                          name={e.code + 'Ingre'}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label={'Extra Info 1'}
                              variant="outlined"
                              inputProps={{
                                maxLength: MAXLENGTH,
                              }}
                              multiline
                              maxRows={3}
                              fullWidth
                              {...field}
                            />
                          )}
                        />
                      </Grid>
                    );
                  })}

                  <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                    <Controller
                      render={({ field }) => (
                        <TextField
                          fullWidth
                          label="Title 2"
                          variant="outlined"
                          inputProps={{
                            maxLength: TITLELENGTH,
                          }}
                          InputLabelProps={{ shrink: true }}
                          {...field}
                        />
                      )}
                      name="title2"
                      control={control}
                    />
                  </Grid>
                  {errors.title2 && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.title2.message}</Typography>
                  )}
                  {langArray.map((e, i) => {
                    return (
                      <Grid key={i} item xs={12} hidden={watchAllFields.select !== e.code}>
                        <Controller
                          name={e.code + 'Title2'}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label="Title 2"
                              variant="outlined"
                              inputProps={{
                                maxLength: MAXLENGTH,
                              }}
                              InputLabelProps={{ shrink: true }}
                              fullWidth
                              {...field}
                            />
                          )}
                        />
                      </Grid>
                    );
                  })}

                  <Grid item xs={12} hidden={watchAllFields.select !== 'en'}>
                    <Controller
                      render={({ field }) => (
                        <TextField
                          fullWidth
                          label={'Extra Info 2'}
                          variant="outlined"
                          inputProps={{
                            maxLength: MAXLENGTH,
                          }}
                          multiline
                          maxRows={3}
                          {...field}
                        />
                      )}
                      name="allergens"
                      control={control}
                    />
                  </Grid>
                  {errors.allergens && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.allergens.message}</Typography>
                  )}
                  {langArray.map((e, i) => {
                    return (
                      <Grid key={i} item xs={12} hidden={watchAllFields.select !== e.code}>
                        <Controller
                          name={e.code + 'Aller'}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label={'Extra Info 2'}
                              variant="outlined"
                              inputProps={{
                                maxLength: MAXLENGTH,
                              }}
                              multiline
                              maxRows={3}
                              fullWidth
                              {...field}
                            />
                          )}
                        />
                      </Grid>
                    );
                  })}
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                {additionPriceOn && (
                  <Grid item xs={12}>
                    <Controller
                      render={({ field }) => (
                        <Select
                          fullWidth
                          defaultValue="USD"
                          {...field}
                          variant="outlined"
                          disabled={!additionPriceOn}
                        >
                          {currencies.map((e, i) => {
                            return (
                              <MenuItem key={i} value={e.code}>
                                {e.name + ' (' + e.code + ')'}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                      name="selectPrice"
                      control={control}
                    />
                  </Grid>
                )}

                <Grid item xs={6} hidden={watchAllFields.selectPrice !== 'USD'}>
                  <Controller
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        label="Product Price"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          startAdornment: <InputAdornment position="start">{primaryCurrencySymbol}</InputAdornment>,
                        }}
                        inputProps={{
                          step: '0.01',
                          min: '0',
                        }}
                        {...field}
                      />
                    )}
                    name="price"
                    control={control}
                    rules={{
                      validate: {
                        required: (v) => (v !== '' && v !== null && v !== undefined) || 'Price is required',
                        min: (v) => Number(v) >= 0 || 'Price must be 0 or greater',
                      },
                    }}
                  />
                  {errors.price && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.price.message}</Typography>
                  )}
                </Grid>

                {additionPriceOn &&
                  noUScurrencies.map((e, i) => {
                    return (
                      <Grid key={i} item xs={6} hidden={watchAllFields.selectPrice !== e.code}>
                        <Controller
                          render={({ field }) => (
                            <TextField
                              fullWidth
                              label="Product Price"
                              variant="outlined"
                              type="number"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    {currentSymbol()}
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{
                                step: '0.01',
                                min: '0',
                              }}
                              {...field}
                            />
                          )}
                          name={e.code + 'Price'}
                          control={control}
                          rules={{ min: 0 }}
                        />
                      </Grid>
                    );
                  })}

                <Grid item xs={6} hidden={watchAllFields.selectPrice !== 'USD'}>
                  <Controller
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        label="Cost Price"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">{primaryCurrencySymbol}</InputAdornment>
                          ),
                        }}
                        inputProps={{
                          step: '0.01',
                          min: '0',
                        }}
                        {...field}
                      />
                    )}
                    name="costPrice"
                    control={control}
                  />
                  {errors.costPrice && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.costPrice.message}</Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        label="External Code"
                        variant="outlined"
                        inputProps={{
                          maxLength: UPC,
                        }}
                        {...field}
                      />
                    )}
                    name="externalCode"
                    control={control}
                  />
                  {errors.externalCode && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.externalCode.message}</Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        label="UPC/SKU"
                        variant="outlined"
                        inputProps={{
                          maxLength: UPC,
                        }}
                        {...field}
                      />
                    )}
                    name="upc"
                    control={control}
                    rules={{ required: 'Upc is required' }}
                  />
                  {errors.upc && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.upc.message}</Typography>
                  )}
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    name="brand"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        InputLabelProps={{ shrink: true }}
                        select
                        label="Brand"
                        fullWidth
                        variant="outlined"
                      >
                        <MenuItem value={null}>
                          <em>None</em>
                        </MenuItem>
                        {brands.length > 0 &&
                          brands.map((e) => {
                            return (
                              <MenuItem key={e._id} value={e._id}>
                                {e.name.en}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                    )}
                  />
                  {errors.brand && (
                    <Typography color="error" sx={{ ml: 1 }}>{errors.brand.message}</Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    name="category"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        multiple
                        options={categories}
                        value={watchAllFields.category}
                        disableCloseOnSelect
                        onChange={(event, value) => {
                          field.onChange(value);
                        }}
                        isOptionEqualToValue={(option, value) => option._id === value._id}
                        getOptionLabel={(option) => option.name.en}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.name.en}
                          </li>
                        )}
                        fullWidth
                        renderInput={(params) => (
                          <TextField {...params} variant="outlined" label="Categories" />
                        )}
                      />
                    )}
                  />
                </Grid>
                {errors.category && (
                  <Typography color="error" sx={{ ml: 1 }}>{errors.category.message}</Typography>
                )}

                {!extra && (
                  <Grid item xs={12}>
                    <Controller
                      name="labels"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          multiple
                          options={labels}
                          value={watchAllFields.labels}
                          disableCloseOnSelect
                          onChange={(event, value) => {
                            field.onChange(value);
                          }}
                          isOptionEqualToValue={(option, value) => option._id === value._id}
                          getOptionLabel={(option) => option.name.en}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                sx={{ mr: 1 }}
                                checked={selected}
                              />
                              {option.name.en}
                            </li>
                          )}
                          fullWidth
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" label="Labels" />
                          )}
                        />
                      )}
                    />
                  </Grid>
                )}
                {!extra && errors.labels && (
                  <Typography color="error" sx={{ ml: 1 }}>{errors.labels.message}</Typography>
                )}

                <Grid item xs={12}>
                  <Controller
                    render={({ field }) => (
                      <Select fullWidth defaultValue="0" {...field} variant="outlined">
                        <MenuItem value="0">Type A</MenuItem>
                        <MenuItem value="1">Type B</MenuItem>
                        <MenuItem value="2">Type C</MenuItem>
                        <MenuItem value="3">Type D</MenuItem>
                      </Select>
                    )}
                    name="tax_type"
                    control={control}
                  />
                </Grid>

                {watchAllFields.ppRadio == 'prod' ? (
                  <Grid container spacing={2} item>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                        Dimensions (cm)
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Controller
                        render={({ field }) => (
                          <TextField
                            fullWidth
                            label="Width"
                            variant="outlined"
                            type="number"
                            defaultValue={defaultValues.length}
                            inputProps={{
                              step: '0.1',
                              min: '0',
                            }}
                            {...field}
                          />
                        )}
                        name="length"
                        rules={{ required: 'Length is required' }}
                        control={control}
                      />
                      {errors.length && (
                        <Typography color="error" sx={{ ml: 1 }}>{errors.length.message}</Typography>
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      <Controller
                        render={({ field }) => (
                          <TextField
                            fullWidth
                            label="Depth"
                            variant="outlined"
                            type="number"
                            defaultValue={defaultValues.width}
                            inputProps={{
                              step: '0.1',
                              min: '0',
                            }}
                            {...field}
                          />
                        )}
                        name="width"
                        rules={{ required: 'Width is required' }}
                        control={control}
                      />
                      {errors.width && (
                        <Typography color="error" sx={{ ml: 1 }}>{errors.width.message}</Typography>
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      <Controller
                        name="height"
                        rules={{ required: 'height is required' }}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            fullWidth
                            label="Height"
                            variant="outlined"
                            defaultValue={defaultValues.height}
                            type="number"
                            inputProps={{
                              step: '0.1',
                              min: '0',
                            }}
                          />
                        )}
                      />
                      {errors.height && (
                        <Typography color="error" sx={{ ml: 1 }}>{errors.height.message}</Typography>
                      )}
                    </Grid>
                    {!extra && (
                      <Grid item xs={12} container>
                        <Grid item xs={4}>
                          Lane Required:
                          {parseFloat(roundUp(watchAllFields.length / LANE_LENGTH, 1)) > 1
                            ? parseFloat(roundUp(watchAllFields.length / LANE_LENGTH, 1))
                            : 1}
                        </Grid>
                        <Grid item xs={4}>
                          Step Required: {Math.ceil(watchAllFields.width / STEP_DEPTH)}
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <Controller
                      name="prods"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          multiple
                          options={productsDash}
                          value={watchAllFields.prods || []}
                          disableCloseOnSelect
                          onChange={(event, value, reason) => {
                            if (reason === 'select-option') {
                              // Allow duplicates by manually appending the selected item
                              const newValue = [...watchAllFields.prods, value[value.length - 1]];

                              if (newValue.length > 3) {
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Oops...',
                                  text: 'You can add only 3 products',
                                });
                              } else {
                                field.onChange(newValue);
                              }
                            } else if (reason === 'remove-option') {
                              // Remove items when unchecked
                              field.onChange(value);
                            }
                          }}
                          isOptionEqualToValue={() => false} // Ensures no item is "checked"
                          getOptionLabel={(option) => option?.name?.en}
                          renderOption={(props, option) => (
                            <li {...props}>
                              {option?.name?.en + ' (' + option?.upc + ')'}
                            </li>
                          )}
                          fullWidth
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Add Products To Bundle"
                            />
                          )}
                        />
                      )}
                    />
                  </Grid>
                )}

                {theme1 && (
                  <Grid container spacing={2} item>
                    <Grid
                      item
                      xs={12}
                      onClick={() => {
                        setArrow(!arrow);
                      }}
                      sx={{ cursor: 'pointer' }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                          Additional Fields
                        </Typography>
                        {!arrow ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                      </Box>
                    </Grid>
                    {arrow && (
                      <Grid container spacing={2} item>
                        <Grid item xs={4}>
                          <Controller
                            name="id_familia"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                type="number"
                                label="id_familia"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Controller
                            name="id_subfamilia"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                type="number"
                                label="id_subfamilia"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Controller
                            name="subconcepto"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                label="subconcepto"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Box sx={{ py: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                      Files
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                      Acceptable formats: jpg, png, and mp4
                      <br />
                      Aspect ratio: 220 px x 170 px or bigger
                      <br />
                      Max. Size: 500KB for images, 10MB for videos
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', height: '48px' }}>
                    <Grid item xs={3}>
                      <Button variant="contained" component="label">
                        Image 1
                        <input
                          {...register('image1', {
                            required: 'Image1 is required',
                            validate: (value) => {
                              if (value && value[0] && value[0].size > IMAGELIMIT) {
                                return 'File size too big, please provide the right size.';
                              }
                              return true;
                            },
                            onChange: (e) => {
                              clearErrors('image1');
                              setPercent(0);
                            },
                          })}
                          type="file"
                          accept=".jpg,.png,.jpeg"
                          hidden
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="body2" className="product-fileName-span">
                        {watchAllFields.image1 &&
                          watchAllFields.image1.length > 0 &&
                          watchAllFields.image1[0].name}
                      </Typography>
                    </Grid>
                    {watchAllFields.image1 && watchAllFields.image1.length > 0 && (
                      <IconButton onClick={() => handleRemove('image1')} size="large">
                        <DeleteForeverOutlined />
                      </IconButton>
                    )}
                  </Box>
                </Grid>
                {errors.image1 && (
                  <Typography color="error" sx={{ ml: 1 }}>{errors.image1.message}</Typography>
                )}

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', height: '48px' }}>
                    <Grid item xs={3}>
                      <Button variant="contained" component="label">
                        Image 2
                        <input
                          {...register('image2', {
                            validate: (value) => {
                              if (value && value[0] && value[0].size > IMAGELIMIT) {
                                return 'File size too big, please provide the right size.';
                              }
                              return true;
                            },
                            onChange: (e) => {
                              clearErrors('image2');
                              setPercent(0);
                            },
                          })}
                          type="file"
                          accept=".jpg,.png,.jpeg"
                          hidden
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="body2" className="product-fileName-span">
                        {watchAllFields.image2 &&
                          watchAllFields.image2.length > 0 &&
                          watchAllFields.image2[0].name}
                      </Typography>
                    </Grid>
                    {watchAllFields.image2 && watchAllFields.image2.length > 0 && (
                      <IconButton onClick={() => handleRemove('image2')} size="large">
                        <DeleteForeverOutlined />
                      </IconButton>
                    )}
                  </Box>
                </Grid>
                {errors.image2 && (
                  <Typography color="error" sx={{ ml: 1 }}>{errors.image2.message}</Typography>
                )}

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', height: '48px' }}>
                    <Grid item xs={3}>
                      <Button variant="contained" component="label">
                        Image 3
                        <input
                          {...register('image3', {
                            validate: (value) => {
                              if (value && value[0] && value[0].size > IMAGELIMIT) {
                                return 'File size too big, please provide the right size.';
                              }
                              return true;
                            },
                            onChange: (e) => {
                              clearErrors('image3');
                              setPercent(0);
                            },
                          })}
                          type="file"
                          accept=".jpg,.png,.jpeg"
                          hidden
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="body2" className="product-fileName-span">
                        {watchAllFields.image3 &&
                          watchAllFields.image3.length > 0 &&
                          watchAllFields.image3[0].name}
                      </Typography>
                    </Grid>
                    {watchAllFields.image3 && watchAllFields.image3.length > 0 && (
                      <IconButton onClick={() => handleRemove('image3')} size="large">
                        <DeleteForeverOutlined />
                      </IconButton>
                    )}
                  </Box>
                </Grid>
                {errors.image3 && (
                  <Typography color="error" sx={{ ml: 1 }}>{errors.image3.message}</Typography>
                )}

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', height: '48px' }}>
                    <Grid item xs={3}>
                      <Button variant="contained" component="label">
                        Video 1
                        <input
                          {...register('video', {
                            validate: (value) => {
                              if (value && value[0] && value[0].size > 10000000) {
                                return 'File size too big, please provide the right size.';
                              }
                              return true;
                            },
                            onChange: (e) => {
                              clearErrors('video');
                              setPercent(0);
                            },
                          })}
                          type="file"
                          accept=".mp4"
                          hidden
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="body2" className="product-fileName-span">
                        {watchAllFields.video &&
                          watchAllFields.video.length > 0 &&
                          watchAllFields.video[0].name}
                      </Typography>
                    </Grid>
                    {watchAllFields.video && watchAllFields.video.length > 0 && (
                      <IconButton onClick={() => handleRemove('video')} size="large">
                        <DeleteForeverOutlined />
                      </IconButton>
                    )}
                  </Box>
                </Grid>

                {errors.video && (
                  <Typography color="error" sx={{ ml: 1 }}>{errors.video.message}</Typography>
                )}
                <Grid item xs={12}>
                  {percent > 0 && <ProgressBar now={percent} active label={`${percent}%`} />}
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      mt: 3,
                      pt: 3,
                      borderTop: `1px solid ${theme.palette.divider}`,
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      sx={{
                        minWidth: 200,
                        py: 1.5,
                        fontSize: '0.95rem',
                        fontWeight: 600,
                        textTransform: 'none',
                      }}
                    >
                      Add Product
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
      </Modal.Body>
    </Modal>
  );
}
